// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"220":"59fa2d3e","282":"c2f44d0f","821":"96a7d41d"}[chunkId] + ".css";
};